import React from "react";
import { Discord, Facebook, Hat2, Instagram, Youtube } from "../constant/Index";
import { useSocialContentQuery } from "../store/services/SitesettingService";

const SocialBanner = () => {
	const { data: socialData, isLoading: socialLoading } = useSocialContentQuery()
	let socialIcons = socialData?.response?.data;
	console.log(socialIcons)
	return (
		<>
			{/* <!-- Follow Sec Start Here --> */}
			<section className="follow_sec">
				<div className="glowing glowing-one">
					<span></span>
				</div>
				<div className="container">
					<div className="hat-circle">
						<figure>
							<img src={Hat2} alt="nft-hat" className="img-fluid" />
						</figure>
					</div>
					<div className="follow_box">
						<div className="row">
							<div className="col-lg-8">
								<div className="content-wrapper">
									<div className="heading-wrapper">
										<h4>SOCIAL MEDIA</h4>
										<h2>FOLLOW US ON SOCIAL MEDIA</h2>
									</div>
									<p>
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et
									</p>
									<ul className="social-medias">
										{socialIcons?.map((data, index) => {
											return (
												<li>
													<a href={data?.link} target="_blank">
														<img src={data?.icon_path} alt="" className="img-fluid" />
													</a>
												</li>
											)
										})}
										{/* <li>
											<a href="#">
												<img src={Instagram} alt="" className="img-fluid" />
											</a>
										</li>
										<li>
											<a href="#">
												<img src={Discord} alt="" className="img-fluid" />
											</a>
										</li>
										<li>
											<a href="#">
												<img src={Youtube} alt="" className="img-fluid" />
											</a>
										</li> */}
									</ul>
								</div>
							</div>
							<div className="col-lg-4"></div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- Follow Sec Start Here --> */}
		</>
	);
};

export default SocialBanner;
